import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { postRopa } from '../../services/apis';

const initialColor = '#000000';

export const FormCrearRopa = ({ open, setOpen, setRopa }) => {
    const colorInputRef = useRef(null);
    const [color, setColor] = useState(initialColor);
    const [foto, setFoto] = useState(null);
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState('');
    const [nuevaRopa, setNuevaRopa] = useState({
        nombre: '',
        color: initialColor
    });

    const handleColorChange = (event) => {
        const nextColor = event.target.value;
        setColor(nextColor);
        setNuevaRopa((prev) => ({ ...prev, color: nextColor }));
    };

    const resetForm = () => {
        setColor(initialColor);
        setFoto(null);
        setError('');
        setNuevaRopa({
            nombre: '',
            color: initialColor
        });
    };

    const cerrar = () => {
        if (guardando) {
            return;
        }

        resetForm();
        setOpen(false);
    };

    const crearRopa = async () => {
        const nombre = nuevaRopa.nombre.trim();
        const colorSeleccionado = nuevaRopa.color || '';

        if (!nombre || (!colorSeleccionado && !foto)) {
            setError('Indica el nom i almenys un color o una foto.');
            return;
        }

        const formData = new FormData();
        formData.append('nombre', nombre);
        formData.append('color', colorSeleccionado);

        if (foto) {
            formData.append('foto', foto);
        }

        setGuardando(true);
        setError('');

        try {
            const response = await postRopa(formData);

            if (response?.success) {
                setRopa(response.data);
                resetForm();
                setOpen(false);
                return;
            }

            setError(response?.message || 'No s\'ha pogut crear la roba.');
        } catch (err) {
            console.error('Error en crear roba:', err);
            setError('No s\'ha pogut crear la roba.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={cerrar}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                Afegir roba
            </DialogTitle>
            <DialogContent>
                <Box className="clothes-form">
                    {error && (
                        <Alert severity="error">
                            {error}
                        </Alert>
                    )}
                    <TextField
                        variant="outlined"
                        name="nombre"
                        label="Nom"
                        fullWidth
                        value={nuevaRopa.nombre}
                        onChange={(event) => setNuevaRopa((prev) => ({ ...prev, nombre: event.target.value }))}
                    />
                    <Box className="clothes-form-color">
                        <Box className="clothes-form-color-copy">
                            <Typography className="clothes-form-label">
                                Color
                            </Typography>
                            <Typography className="clothes-form-code">
                                {color}
                            </Typography>
                        </Box>
                        <input
                            type="color"
                            ref={colorInputRef}
                            value={color}
                            onChange={handleColorChange}
                            id="primary_color"
                        />
                    </Box>
                    <Button variant="outlined" component="label" className="clothes-upload-button" startIcon={<AttachFileIcon />}>
                        {foto ? foto.name : 'Afegir foto'}
                        <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(event) => setFoto(event.target.files?.[0] || null)}
                        />
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions className="clothes-dialog-actions">
                <Button onClick={cerrar} disabled={guardando}>Cancel·lar</Button>
                <Button onClick={crearRopa} variant="contained" autoFocus disabled={guardando}>
                    {guardando ? 'Afegint...' : 'Afegir'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
